import { useNavigate } from "react-router";
import Header from "@components/Header/Header";
import TextInput from "@components/TextInput/TextInput";
import PrimaryButton from "@components/PrimaryButton/PrimaryButton";
import Checkbox from "@components/Checkbox/Checkbox";
import { useRef, useState } from "react";
import BottomSheet from "@components/BottomSheet/BottomSheet";
import BottomSheetHeader from "@components/BottomSheetHeader/BottomSheetHeader";
import { BottomSheetInputAmount } from "@components/BottomSheetInputAmount/BottomSheetInputAmount";
import { Container, ContentContainer, BottomSheetContainer, ButtonContainer, CheckboxContainer } from "./P2POneTimeTransfer.styles";
import { useTranslation } from "react-i18next";

const P2POneTimeTransfer = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const nameInputRef = useRef<HTMLInputElement>(null);
    const addressInputRef = useRef<HTMLInputElement>(null);
    const [saveAddress, setSaveAddress] = useState(false);
    const [isNameInputOpen, setIsNameInputOpen] = useState(false)
    const [isInputAmountOpen, setIsInputAmountOpen] = useState(false)
    const [recipient, setRecipient] = useState({
        address: '',
        name: '',
        isNameError: false,
        isAddressError: false
    })

    const handleCheckboxChange = () => {
        setSaveAddress(!saveAddress);
    };

    const handleInputAmountSubmit = (amount: number) => {
        navigate('/p2p-transfer-confirmation/one-time', {
            state: {
                amount,
                address: recipient.address,
                name: recipient.name,
                save_address: saveAddress
            }
        })
    }

    const validateName = () => {
        if (!recipient.name) {
            setRecipient(prev => ({
                ...prev,
                isNameError: true
            }))
        } else {
            setRecipient(prev => ({
                ...prev,
                isNameError: false
            }))
        }
    }

    const handleMainContinue = () => {
        if (saveAddress) {
            setIsNameInputOpen(true)
        } else {
            setIsInputAmountOpen(true)
        }
    }

    const handleNameSubmit = () => {
        setIsInputAmountOpen(true)
    }

    return (
        <Container>
            <Header title={t('p2p.oneTimeTransfer.header')} showBackButton onBackClick={() => navigate('/p2p-transfer')} />
            <ContentContainer>
                <TextInput
                    title={t('p2p.oneTimeTransfer.recipientWallet')}
                    placeholder={t('p2p.oneTimeTransfer.walletAddressPlaceholder')}
                    value={recipient.address}
                    onChange={(e) => setRecipient(prev => ({
                        ...prev,
                        address: e.target.value
                    }))}
                    ref={addressInputRef}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === 'Tab') {
                            e.preventDefault();
                            addressInputRef.current?.blur();
                        }
                    }}
                />
                <CheckboxContainer>
                    <Checkbox
                        checked={saveAddress}
                        onChange={handleCheckboxChange}
                        label={t('p2p.oneTimeTransfer.saveToAddressBook')}
                    />
                </CheckboxContainer>
            </ContentContainer>
            <BottomSheet
                isOpen={isNameInputOpen}
                onClose={() => setIsNameInputOpen(false)}
                height='270px'
                header={
                    <BottomSheetHeader title={t('p2p.oneTimeTransfer.bottomSheet.header')} />
                }
            >
                <BottomSheetContainer>
                    <TextInput
                        title={t('p2p.oneTimeTransfer.bottomSheet.recipientName')}
                        placeholder={t('p2p.oneTimeTransfer.bottomSheet.namePlaceholder')}
                        value={recipient.name}
                        onChange={(e) => setRecipient(prev => ({
                            ...prev,
                            name: e.target.value
                        }))}
                        errorText={t('p2p.oneTimeTransfer.bottomSheet.invalidName')}
                        isError={recipient.isNameError}
                        onBlur={validateName}
                        ref={nameInputRef}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === 'Tab') {
                                e.preventDefault();
                                nameInputRef.current?.blur();
                            }
                        }}
                    />
                    <PrimaryButton
                        onClick={handleNameSubmit}
                        disabled={!recipient.name || recipient.isNameError}
                    >
                        {t('p2p.oneTimeTransfer.bottomSheet.continueButton')}
                    </PrimaryButton>
                </BottomSheetContainer>
            </BottomSheet>
            <BottomSheetInputAmount
                isOpen={isInputAmountOpen}
                onClose={() => setIsInputAmountOpen(false)}
                onContinue={handleInputAmountSubmit}
            />
            <ButtonContainer>
                <PrimaryButton
                    disabled={!recipient.address}
                    onClick={handleMainContinue}
                >
                    {t('p2p.oneTimeTransfer.bottomSheet.continueButton')}
                </PrimaryButton>
            </ButtonContainer>
        </Container>
    );
};

export default P2POneTimeTransfer;